export default __webpack_public_path__ + "static/media/cf04151a1f037d1797aed6fdb8b37210.svg";